import Database from "./Database"

class WMProductCategories {
    getAll() {
        return Database.getAll("product_categories")
    }
}

const ProductCategories = new WMProductCategories()
export default ProductCategories